import { createStore } from 'zustand';

export type PendingSignupState = {
  token: string;
  maskedEmail: string;
  returnUrl?: string;
};

export const pendingSignupStore = createStore<PendingSignupState>(() => {
  return {
    token: '',
    maskedEmail: '',
  };
});

export const setPendingSignup = (pendingSignup: PendingSignupState) => {
  pendingSignupStore.setState(pendingSignup, true);
};

export const replacePendingSignupToken = (token: string) => {
  pendingSignupStore.setState({ token });
};

export const clearPendingSignup = () => {
  pendingSignupStore.setState(pendingSignupStore.getInitialState(), true);
};
